import React, { useState } from "react";
import { Select, Space, Input, DatePicker, Typography } from "antd";

const { Text } = Typography;

const VoucherRedemptionFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("voucherName");
  const searchBy = (
    <Select
      defaultValue="voucherName"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="voucherName">Voucher Name</Select.Option>
      <Select.Option value="userEmail">User Email</Select.Option>
      <Select.Option value="orderId">Order Id</Select.Option>
    </Select>
  );

  return (
    <Space size="large">
      <Space direction="vertical" size={4}>
        <Text>Dispatched Date</Text>
        <DatePicker.RangePicker
          value={[filters.dispatchStartDate, filters.dispatchEndDate]}
          onChange={(dates) =>
            dates
              ? onFiltersChange({
                  ...filters,
                  dispatchStartDate: dates[0],
                  dispatchEndDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  dispatchStartDate: undefined,
                  dispatchEndDate: undefined,
                })
          }
        />
      </Space>

      <Space direction="vertical" size={4}>
        <Text>Redeemed Date</Text>
        <DatePicker.RangePicker
          value={[filters.redeemStartDate, filters.redeemEndDate]}
          onChange={(dates) =>
            dates
              ? onFiltersChange({
                  ...filters,
                  redeemStartDate: dates[0],
                  redeemEndDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  redeemStartDate: undefined,
                  redeemEndDate: undefined,
                })
          }
        />
      </Space>

      <Space direction="vertical" size={4}>
        <Text>Search</Text>
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={(term) =>
            onFiltersChange({ ...filters, search: term, searchField })
          }
          allowClear
        />
      </Space>

      <Space direction="vertical" size={4}>
        <Text>Status</Text>
        <Select
          style={{ width: 150 }}
          placeholder="Select"
          onChange={(value) => {
            onFiltersChange({ ...filters, status: value });
          }}
          allowClear
        >
          <Select.Option value="unredeemed">Available</Select.Option>
          <Select.Option value="redeemed">Redeemed</Select.Option>
          <Select.Option value="expired">Expired</Select.Option>
        </Select>
      </Space>
    </Space>
  );
};

export default VoucherRedemptionFilters;
